import { get as _get } from 'lodash';
import { SiteContext } from '@nucleus/web-theme';
import { useContext } from 'react';

export const usePostHubPath = (engineId?: string): string => {
  const { getSite } = useContext(SiteContext);
  const postHub = getSite().hubs.find((hub) => hub.id === engineId);
  return _get(postHub, 'paths[0]', '');
};

